module.exports = __webpack_public_path__ + "/7cc67ec927b7035d5a23c45a44a00578.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/integrations/assets/onedrive.svg
 ** module id = 1609
 ** module chunks = 0
 **/